module.exports = __webpack_public_path__ + "img/icon-flag-denmark.19681347.png";